import * as React from 'react';

const AuthError = () => 
  <div>You aren't allowed to visit that page</div>

export default AuthError
